import { ComponentType } from 'react'
import { lazyWithReload } from '../utils/lazyWithReload'
// import Integrations from '../components/Integrations/Integrations'
import UnverifiedUserPage from '../components/Miscellaneous/UnverifiedUserPage'
import { Auth0CallbackPage } from '../components/Miscellaneous/Auth0CallbackPage'
import Empty from '../components/Layout/SideNav/Empty'
import { RoutePaths, UserPermissions } from '../constants/constants'
import Home from '../components/Layout/MainContent/Home'
// import Flashtrak from '../components/Applications/FlashTrak'
//Below is a test componet. Not part of application
// import CardComponent from '../components/Test/CardLayout/CardComponent'

/*
 * UBQ-5897: every screen except the login-critical ones (Home, Auth0 callback, unverified user,
 * the empty placeholder) is its own chunk, so the first load (the login page) no longer downloads
 * the whole app. Keep new routes lazy: a static import here pulls the screen, and every library it
 * uses, back into the entry bundle. RoutesComponent wraps the route tree in <Suspense>.
 */
const UserManagement = lazyWithReload(
    () => import('../components/UserManagement'),
)
const Organizations = lazyWithReload(
    () => import('../components/Organizations'),
)
const DTStudio = lazyWithReload(() => import('../components/DTStudio'))
const UserGroups = lazyWithReload(() => import('../components/UserGroups'))
const UsersListInGroup = lazyWithReload(
    () => import('../components/UserGroups/UsersListInGroup'),
)
const FMTabs = lazyWithReload(
    () => import('../components/Applications/FacilityManagement/FMTabs'),
)
const InTransitTabs = lazyWithReload(
    () => import('../components/Applications/Intransit'),
)
const Analytics = lazyWithReload(
    () => import('../components/Applications/Analytics'),
)
const ViewAnalytics = lazyWithReload(
    () => import('../components/Applications/Analytics/ViewAnalytics'),
)
const Programs = lazyWithReload(() => import('../components/Programs'))
const ViewEntity = lazyWithReload(() => import('../components/ViewEntity'))
const ShipmentSearchGuest = lazyWithReload(
    () => import('../components/Applications/GuestApps/ShipmentSearchGuest'),
)
const DeviceManager = lazyWithReload(
    () => import('../components/Applications/DeviceManager'),
)
const UploadManager = lazyWithReload(
    () => import('../components/Applications/UploadManager'),
)
const EntityPage = lazyWithReload(() => import('../components/EntityPage'))
const ShipmentPreviewGuest2 = lazyWithReload(() =>
    import('../components/Applications/GuestApps/ShipmentPreviewGuest').then(
        (m) => ({ default: m.ShipmentPreviewGuest2 }),
    ),
)

export interface RoutesType {
    path: string
    exact: boolean
    component: ComponentType
    requiredAuthGuard: boolean
    permissions: UserPermissions[]
    hasPermission: boolean
    redirectPath?: string
}

const initialRoutes: RoutesType[] = [
    {
        path: RoutePaths.Home,
        exact: true,
        component: Home,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/entity/:templateName/:templateId',
        exact: true,
        component: EntityPage,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.entityPreview,
        exact: true,
        component: ViewEntity,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/admin/:templateName/:templateId',
        exact: true,
        component: EntityPage,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.ORG_ADMIN,
            UserPermissions.SYSTEM_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: '/insurance',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: '/coc',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: '/doc-management',
        exact: true,
        component: Empty,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.userManagement,
        exact: true,
        component: UserManagement,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.userGroups,
        exact: true,
        component: UserGroups,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: '/user-group/:groupName/:groupId',
        exact: true,
        component: UsersListInGroup,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.SYSTEM_READER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.organizations,
        exact: true,
        component: Organizations,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.programs,
        exact: true,
        component: Programs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.unverifiedUser,
        exact: true,
        component: UnverifiedUserPage,
        requiredAuthGuard: false,
        permissions: [],
        hasPermission: true,
    },
    {
        path: RoutePaths.dtStudio,
        exact: true,
        component: DTStudio,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
        redirectPath: RoutePaths.networkAdmin,
    },
    {
        path: RoutePaths.networkAdmin,
        exact: true,
        component: DTStudio,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
    // {
    //     path: RoutePaths.flashtrak,
    //     exact: true,
    //     component: Flashtrak,
    //     requiredAuthGuard: true,
    //     permissions: [UserPermissions.ENTITY_READER,
    //     hasPermission: false,
    // },
    {
        path: RoutePaths.facilityMonitoring,
        exact: true,
        component: FMTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: '/callback',
        exact: true,
        component: Auth0CallbackPage,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.analytics,
        exact: true,
        component: Analytics,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.analyticsPreview,
        exact: true,
        component: ViewAnalytics,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_ANALYST],
        hasPermission: false,
    },
    {
        path: RoutePaths.inTransit,
        exact: true,
        component: InTransitTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
        redirectPath: RoutePaths.ccl,
    },
    {
        path: RoutePaths.ccl,
        exact: true,
        component: InTransitTabs,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: false,
    },
    {
        path: RoutePaths.guestUserShipment,
        exact: true,
        component: ShipmentSearchGuest,
        requiredAuthGuard: false,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: true,
    },
    {
        path: '/guestUser/shipment/:shipmentId',
        exact: true,
        component: ShipmentPreviewGuest2,
        requiredAuthGuard: false,
        permissions: [UserPermissions.ENTITY_READER],
        hasPermission: true,
    },
    {
        path: RoutePaths.deviceManager,
        exact: true,
        component: DeviceManager,
        requiredAuthGuard: true,
        permissions: [
            UserPermissions.USER_ADMIN,
            UserPermissions.DEVICE_WRITER,
        ],
        hasPermission: false,
    },
    {
        path: RoutePaths.uploadManager,
        exact: true,
        component: UploadManager,
        requiredAuthGuard: true,
        permissions: [UserPermissions.ORG_ADMIN, UserPermissions.SYSTEM_READER],
        hasPermission: false,
    },
]

export default initialRoutes
